import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Injectable} from '@angular/core';

@Injectable()
export class NgbDateFRParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    // parse mm/dd/yyy
    const parts = value.split('/');
    return (parts.length === 3) ? {year: parseInt(parts[2], 10), month: parseInt(parts[0], 10), day: parseInt(parts[1], 10)} : null;
  }

  format(date: NgbDateStruct): string {
    return (date) ? '' + date.month + '/' + date.day + '/' + date.year : '';
  }
}
